import { kea } from 'kea'
import PropTypes from 'prop-types';
import { put } from 'redux-saga/effects'

import { __ } from '~/i18n'
import { actions as configActions } from '~/config'
import rootLogic from '~/scenes/logic'
import entities from '~/entities'

export default kea({
  path: () => ['scenes', 'order'],

  connect: {
    actions: [
      rootLogic, [
        'retryPayment',
        'cancelPayment',
        'closeCart'
      ]
    ],
    values: [
      rootLogic, [
        'retrying',
        'cancelled',
        'paymentUrl',
        'orderPaymentMethod'
      ],
      entities, [
        'activeOrder'
      ]
    ]
  },

  selectors : ({ constants, selectors }) => ({
    showButton: [
      () => [
        selectors.orderPaymentMethod,
      ], (orderPaymentMethod) => {
        return orderPaymentMethod && orderPaymentMethod.type === 'ShopBankDepositMethod';
      },
      PropTypes.bool,
    ],
    showSpinner: [
      () => [
        selectors.orderPaymentMethod,
      ], (orderPaymentMethod) => {
        return orderPaymentMethod && ['ShopMaksekeskusMethod', 'ShopPaypalMethod', 'ShopPayseraMethod', 'ShopGratifyMethod'].indexOf(orderPaymentMethod.type) > -1;
      },
      PropTypes.bool,
    ],
    infoText: [
      () => [
        selectors.orderPaymentMethod,
      ], (orderPaymentMethod) => {
        if(orderPaymentMethod && ['ShopMaksekeskusMethod', 'ShopPaypalMethod', 'ShopPayseraMethod', 'ShopGratifyMethod'].indexOf(orderPaymentMethod.type) > -1) {
          return __("You will now be redirected to the payment page.")
        }

        return null;
      },
      PropTypes.string,
    ]
  }),

  actions: () => ({
    commit: true,
    cancel: true,
  }),

  takeLatest: ({ actions, workers }) => ({
    [actions.commit]: function * () {
      const url = yield this.get('paymentUrl');

      if(typeof window !== 'undefined') {
        window.location = url;
      }
    },
    [actions.cancel]: function * () {
      try {
        document.body.classList.remove('dimmable', 'dimmed', 'scrolling')
      } catch (e) {

      }
      yield put(configActions.clearActiveCart());
    },
  })
})
